/* eslint-disable no-nested-ternary */
/* eslint-disable object-shorthand */
import { Box, Button, CircularProgress, styled } from "@mui/material";
import React from "react";
import Iconify from "./Iconify";

const CustomButton = ({
  backgroundColor,
  color,
  buttonText,
  heroBtn,
  guideBtn,
  getStartedBtn,
  type,
  startIcon,
  loading,
  ...buttonProps
}) => {
  const CustomButton = styled(Button)(({ theme }) => (type === 'primaire' ? {
    textTransform: 'initial',
    border: '2px solid transparent',
    color: 'white',
    paddingLeft: 20,
    paddingRight: 20,
    backgroundColor: '#5E17EB',
    borderRadius: '7px',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#A47CF4',
      color: 'white',
      borderColor: '#A47CF4',
    },

  } : type === 'secondaire' ? {
    textTransform: 'initial',
    border: '2px solid #1F1F1F',
    color: '#1F1F1F',
    backgroundColor: 'white',
    borderRadius: '7px',
    paddingLeft: 20,
    paddingRight: 20,
    borderColor: '#1F1F1F',
    '&:hover': {
      backgroundColor: 'white',
      color: '#1F1F1F',
    },

  } : type === 'tertiaire' ? {
    textTransform: "initial",
    border: "2px solid #5E17EB",
    backgroundColor: "#5E17EB",
    color: "white",
    borderRadius: "7px",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#5E17EB",
      border: "2px solid #5E17EB",
      color: "white",
    },

  } : type === 'back' ? {
    textTransform: 'initial',
    border: '2px solid transparent',
    color: '#141414',
    backgroundColor: 'transparent',
    borderRadius: '7px',
    borderColor: 'transparent',
    paddingLeft: 20,
    paddingRight: 20,
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#141414',
      borderColor: 'transparent',
    },

  } : {
    textTransform: 'initial',
    border: '2px solid transparent',
    color: 'white',
    backgroundColor: '#5E17EB',
    borderRadius: '7px',
    paddingLeft: 20,
    paddingRight: 20,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'white',
      color: '#5E17EB',
      borderColor: '#5E17EB',
    },

  }));

  return <CustomButton {...buttonProps} startIcon={startIcon} loading={loading} loadingPosition="end" size="large">
    {
      loading ? <CircularProgress size={26} sx={{ color: "white" }} /> : buttonText
    }

    
  </CustomButton>;
};

export default CustomButton;